import * as Types from '../../types';

export const isMaintenanceModeEnabled = (config: Types.IMaintenanceDataResponse): boolean => {
    if (!config || !config.isMaintenanceEnabled) {
        return false;
    }

    if (!config.isAutoDetectEnabled && !config.isSchedulerEnabled) {
        return true;
    }

    if (config.isAutoDetectEnabled && !config.isSchedulerEnabled) {
        return false;
    }

    const currentDate = Date.now();
    const startDate = Date.parse(config.startDate);
    const endDate = Date.parse(config.endDate);

    return startDate <= currentDate && currentDate < endDate;
};
